import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import Header from "../../components/header";
const ContactUs = () => {
  const [isCopied, setIsCopied] = useState(false);
  const [isHovered, setIsHovered] = useState({
    address: false,
    phone: false,
    email: false
  });

  const handlePhoneClick = () => {
    window.location.href = 'tel:0780211698';
  };

  const handleEmailClick = (e) => {
    e.preventDefault();
    window.location.href = 'mailto:blessie999@gmail.com';
  };
  
  const handleAddressClick = async (event) => {
    event.preventDefault();
    const address = encodeURIComponent('362 Laydes Street, Pretoria');
    const mapsUrl = `https://www.google.com/maps/search/?api=1&query=${address}`;

    try {
      await navigator.clipboard.writeText('362 Laydes Street, Pretoria');
      setIsCopied(true);
      setTimeout(() => setIsCopied(false), 2000);
      window.open(mapsUrl, '_blank', 'noopener,noreferrer');
    } catch (err) {
      console.error('Failed to copy address:', err);
    }
  };

  // Animation variants
  const containerVariants = {
    hidden: { opacity: 0 },
    visible: {
      opacity: 1,
      transition: {
        staggerChildren: 0.2,
        when: "beforeChildren"
      }
    }
  };

  const itemVariants = {
    hidden: { y: 20, opacity: 0 },
    visible: {
      y: 0,
      opacity: 1,
      transition: {
        duration: 0.5,
        ease: "easeOut"
      }
    }
  };

  const cardHoverVariants = {
    hover: {
      y: -10,
      boxShadow: "0 20px 40px rgba(0, 0, 0, 0.1)",
      transition: {
        duration: 0.3,
        ease: "easeOut"
      }
    }
  };

  return (
    <motion.section 
      className="contact-us-section"
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      transition={{ duration: 0.5 }}
    ><Header/>
      <div className="contact-container">
        <motion.div 
          className="contact-header"
          initial={{ y: -50, opacity: 0 }}
          animate={{ y: 0, opacity: 1 }}
          transition={{ duration: 0.6, delay: 0.2 }}
        >
          <h1 className="contact-title">Let's Connect</h1>
          <motion.p 
            className="contact-subtitle"
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            transition={{ delay: 0.4, duration: 0.8 }}
          >
            We'd love to hear from you. Reach out for collaborations, questions, or just to say hello!
          </motion.p>
        </motion.div>

        <motion.div 
          className="contact-content"
          variants={containerVariants}
          initial="hidden"
          animate="visible"
        >
          <motion.div 
            className="contact-info-card"
            variants={itemVariants}
            whileHover={cardHoverVariants.hover}
          >
            <div className="contact-info-header">
              <div className="contact-icon">
                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="#5cb6f9" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                  <path d="M21 10c0 7-9 13-9 13s-9-6-9-13a9 9 0 0 1 18 0z"></path>
                  <circle cx="12" cy="10" r="3"></circle>
                </svg>
              </div>
              <h2 className="contact-info-title">Our Location</h2>
            </div>
            <motion.p 
              className="contact-detail"
              onClick={handleAddressClick}
              whileHover={{ scale: 1.02 }}
              whileTap={{ scale: 0.98 }}
              onHoverStart={() => setIsHovered({...isHovered, address: true})}
              onHoverEnd={() => setIsHovered({...isHovered, address: false})}
            >
              <span className="contact-label">Address:</span> 
              <span className="contact-value">362 Laydes Street, Pretoria</span>
              <AnimatePresence>
                {isHovered.address && (
                  <motion.span 
                    className="contact-hint"
                    initial={{ opacity: 0, x: 10 }}
                    animate={{ opacity: 1, x: 0 }}
                    exit={{ opacity: 0, x: 10 }}
                  >
                    Click to open maps
                  </motion.span>
                )}
              </AnimatePresence>
            </motion.p>
            <AnimatePresence>
              {isCopied && (
                <motion.div 
                  className="copy-notification"
                  initial={{ opacity: 0, y: 10 }}
                  animate={{ opacity: 1, y: 0 }}
                  exit={{ opacity: 0, y: -10 }}
                >
                  Address copied to clipboard!
                </motion.div>
              )}
            </AnimatePresence>
          </motion.div>

          <motion.div 
            className="contact-info-card"
            variants={itemVariants}
            whileHover={cardHoverVariants.hover}
          >
            <div className="contact-info-header">
              <div className="contact-icon">
                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="#5cb6f9" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                  <path d="M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07 19.5 19.5 0 0 1-6-6 19.79 19.79 0 0 1-3.07-8.67A2 2 0 0 1 4.11 2h3a2 2 0 0 1 2 1.72 12.84 12.84 0 0 0 .7 2.81 2 2 0 0 1-.45 2.11L8.09 9.91a16 16 0 0 0 6 6l1.27-1.27a2 2 0 0 1 2.11-.45 12.84 12.84 0 0 0 2.81.7A2 2 0 0 1 22 16.92z"></path>
                </svg>
              </div>
              <h2 className="contact-info-title">Phone</h2>
            </div>
            <motion.p 
              className="contact-detail"
              onClick={handlePhoneClick}
              whileHover={{ scale: 1.02 }}
              whileTap={{ scale: 0.98 }}
              onHoverStart={() => setIsHovered({...isHovered, phone: true})}
              onHoverEnd={() => setIsHovered({...isHovered, phone: false})}
            >
              <span className="contact-label">Call us:</span> 
              <span className="contact-value">078 021 1698</span>
              <AnimatePresence>
                {isHovered.phone && (
                  <motion.span 
                    className="contact-hint"
                    initial={{ opacity: 0, x: 10 }}
                    animate={{ opacity: 1, x: 0 }}
                    exit={{ opacity: 0, x: 10 }}
                  >
                    Click to call
                  </motion.span>
                )}
              </AnimatePresence>
            </motion.p>
          </motion.div>

          <motion.div 
            className="contact-info-card"
            variants={itemVariants}
            whileHover={cardHoverVariants.hover}
          >
            <div className="contact-info-header">
              <div className="contact-icon">
                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="#5cb6f9" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                  <path d="M4 4h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2z"></path>
                  <polyline points="22,6 12,13 2,6"></polyline>
                </svg>
              </div>
              <h2 className="contact-info-title">Email</h2>
            </div>
            <motion.p 
              className="contact-detail"
              onClick={handleEmailClick}
              whileHover={{ scale: 1.02 }}
              whileTap={{ scale: 0.98 }}
              onHoverStart={() => setIsHovered({...isHovered, email: true})}
              onHoverEnd={() => setIsHovered({...isHovered, email: false})}
            >
              <span className="contact-label">Email us:</span> 
              <span className="contact-value">blessie999@gmail.com</span>
              <AnimatePresence>
                {isHovered.email && (
                  <motion.span 
                    className="contact-hint"
                    initial={{ opacity: 0, x: 10 }}
                    animate={{ opacity: 1, x: 0 }}
                    exit={{ opacity: 0, x: 10 }}
                  >
                    Click to email
                  </motion.span>
                )}
              </AnimatePresence>
            </motion.p>
          </motion.div>
        </motion.div>
      </div>

      <style jsx global>{`
        @import url('https://fonts.googleapis.com/css2?family=Poppins:wght@300;400;500;600;700&display=swap');
        
        * {
          box-sizing: border-box;
          margin: 0;
          padding: 0;
        }
        
        body {
          font-family: 'Poppins', sans-serif;
          background-color: white;
          color: #333;
          line-height: 1.6;
        }
      `}</style>

      <style jsx>{`
        .contact-us-section {
          position: relative;
          min-height: 100vh;
          padding: 80px 20px;
          overflow: hidden;
          background-color: white;
        }
        
        .contact-container {
          position: relative;
          max-width: 1200px;
          margin: 0 auto;
          z-index: 1;
        }
        
        .contact-header {
          text-align: center;
          margin-bottom: 60px;
        }
        
        .contact-title {
          font-size: 3.5rem;
          font-weight: 700;
          margin-bottom: 20px;
          background: linear-gradient(90deg, #5cb6f9, #01224a);
          -webkit-background-clip: text;
          -webkit-text-fill-color: transparent;
          background-clip: text;
        }
        
        .contact-subtitle {
          font-size: 1.25rem;
          font-weight: 300;
          max-width: 700px;
          margin: 0 auto;
          color: #666;
        }
        
        .contact-content {
          display: grid;
          grid-template-columns: repeat(auto-fit, minmax(300px, 1fr));
          gap: 30px;
          margin-top: 40px;
        }
        
        .contact-info-card {
          background: white;
          border-radius: 16px;
          padding: 30px;
          border: 1px solid rgba(0, 0, 0, 0.1);
          box-shadow: 0 4px 20px rgba(0, 0, 0, 0.05);
          transition: all 0.3s ease;
          cursor: default;
          position: relative;
          overflow: hidden;
        }
        
        .contact-info-card::before {
          content: '';
          position: absolute;
          top: 0;
          left: 0;
          width: 100%;
          height: 100%;
          background: linear-gradient(45deg, transparent, rgba(92, 182, 249, 0.05), transparent);
          transform: translateX(-100%);
          transition: transform 0.6s ease;
        }
        
        .contact-info-card:hover::before {
          transform: translateX(100%);
        }
        
        .contact-info-header {
          display: flex;
          align-items: center;
          margin-bottom: 25px;
        }
        
        .contact-icon {
          width: 50px;
          height: 50px;
          border-radius: 50%;
          background: rgba(92, 182, 249, 0.1);
          display: flex;
          align-items: center;
          justify-content: center;
          margin-right: 15px;
        }
        
        .contact-info-title {
          font-size: 1.5rem;
          font-weight: 600;
          color: #01224a;
          margin: 0;
        }
        
        .contact-detail {
          font-size: 1.1rem;
          margin-bottom: 15px;
          position: relative;
          padding-left: 30px;
          cursor: pointer;
          display: flex;
          flex-wrap: wrap;
          align-items: center;
          color: #333;
        }
        
        .contact-label {
          font-weight: 500;
          margin-right: 8px;
          color: #666;
        }
        
        .contact-value {
          color: #01224a;
          font-weight: 400;
        }
        
        .contact-hint {
          font-size: 0.8rem;
          background: rgba(92, 182, 249, 0.1);
          padding: 3px 8px;
          border-radius: 4px;
          margin-left: 10px;
          color: #5cb6f9;
        }
        
        .copy-notification {
          position: absolute;
          bottom: 20px;
          left: 50%;
          transform: translateX(-50%);
          background: #5cb6f9;
          color: white;
          padding: 8px 15px;
          border-radius: 20px;
          font-size: 0.9rem;
          font-weight: 500;
          box-shadow: 0 4px 15px rgba(92, 182, 249, 0.2);
        }
        
        @media (max-width: 768px) {
          .contact-title {
            font-size: 2.5rem;
          }
          
          .contact-subtitle {
            font-size: 1rem;
          }
          
          .contact-content {
            grid-template-columns: 1fr;
          }
        }
      `}</style>
    </motion.section>
  );
};

export default ContactUs;